import React from 'react';
import { useSession } from '@hum/api/src/Session/useSession';
import { getCompany, useApiQuery } from '@hum/api';
import { OnboardingConnectStep } from './onboarding-v5/components/OnboardingConnectStep';
import { CompanyActivation } from './company-activation';
import { CompanyInsights } from './insights/CompanyInsights';
import { ConnectPage } from './connect';
import { UploadFiles } from './onboarding-v5/components/UploadFiles';
import { FinalPage } from './onboarding-v5/components/FinalPage';
import { useFlags } from '@hum/icm-app/src/hooks/useFlags';
import { V2Redirect } from './V2Redirect';
import { Spinner } from '@hum/ui-library';
import { Route } from 'react-router-dom';
import { Routes } from '../state';

function CompanyApp() {
  const flags = useFlags();
  const { user } = useSession();
  const company = useApiQuery(getCompany);

  if (!user?.emailVerified || !user?.organizationId) return <V2Redirect />;

  if (!company.data && company.isLoading) return <Spinner fullScreen />;

  const companyActivationRoutes = [
    Routes.COMPANY_ACTIVATION_CONNECTORS,
    Routes.COMPANY_ACTIVATION_CONNECTORS_ACCOUNTING,
    Routes.COMPANY_ACTIVATION_CONNECTORS_PAYMENT,
    Routes.COMPANY_ACTIVATION_CONNECTORS_BANK,
    Routes.COMPANY_ACTIVATION_ROOT,
    Routes.COMPANY_ACTIVATION_DOCUMENT_DATAROOM,
  ];

  return (
    <>
      <Route path={Routes.ROOT} exact component={V2Redirect} />
      {companyActivationRoutes.map((path) => (
        <Route key={path} path={path} exact component={CompanyActivation} />
      ))}
      <Route
        path={Routes.COMPANY_ACTIVATION_CONNECTORS_CONNECT}
        exact
        component={OnboardingConnectStep}
      />
      <Route
        path={[Routes.INSIGHTS_CHART_TAB, Routes.INSIGHTS]}
        component={CompanyInsights}
      />
      <Route path={Routes.CONNECT} component={ConnectPage} />

      {flags.ready && (
        <Route path={Routes.ONBOARDING_V5_CONNECT}>
          <OnboardingConnectStep isOnboarding />
        </Route>
      )}
      <Route path={Routes.ONBOARDING_V5_UPLOAD_FILES}>
        <UploadFiles />
      </Route>

      {/* Finished */}
      <Route path={Routes.ONBOARDING_V5_COMPLETED}>
        <FinalPage />
      </Route>
    </>
  );
}

export default CompanyApp;
